import { getLocale } from "../runtime";

const sv_dkcountryenglish = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Denmark`
};

const dkcountryenglish = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_dkcountryenglish(inputs)
	return "dkCountryEnglish";
};

export { dkcountryenglish as "dkCountryEnglish" };